// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3593":"f8b481d94abc3aa5","7117":"3dd81c0e18a02d8d"}[chunkId] + ".css";
};